import React from 'react';
import { FaTools } from 'react-icons/fa';
import { GLOBAL_COLORS } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { SKILL_LEVEL, SKILL_TYPES } from './helpers/skillLevel';
import './SliderInstance.css';

interface SliderInstanceProps {
  skillName: string;
  skillType: string;
  starCount: number;
  openPopup: (skill: {
    name: string;
    starCount: number;
    skillType: string;
  }) => void;
  sectionType: 'earned' | 'selfReported' | 'desired';
}

export const SliderInstance: React.FC<SliderInstanceProps> = ({
  skillName,
  skillType,
  starCount,
  openPopup,
  sectionType,
}) => {
  const { t } = useTranslation('library');

    const calculatePercentage = (value) => {
    if (value) {
      return (value / 5) * 100;
    }
    return 0;
  };

  const MAX_NAME_LENGTH = 35;
  const truncatedName =
    skillName.length > MAX_NAME_LENGTH
      ? skillName.slice(0, MAX_NAME_LENGTH) + '...'
      : skillName;

  const isSelfReported = sectionType === SKILL_TYPES.SELF_REPORTED;

  return (
    <div
      className={`slider-instance-card ${
        isSelfReported ? 'slider-self-reported' : 'slider-other-type'
      }`}
      onClick={() =>
        openPopup({ name: skillName, starCount, skillType })
      }
    >
      <div className="slider-content">
        <a href="#" className="slider-link" onClick={(e) => e.preventDefault()}>
          <div className="slider-inner-box">
            <div>
              <div className="icon-center">
                <FaTools
                  color={GLOBAL_COLORS.icon_color}
                  className="image-141"
                  style={{ width: '26px', height: '26px' }}
                />
              </div>

              <div className="text-block-257 skill-name" title={skillName}>
                {skillName}
              </div>

              {starCount > 0 && (
                <div>
                  <div className="html-embed-10 w-embed">
                    <div className="star-wrapper">
                      <div
                        className="circle per-25"
                        style={{
                          backgroundImage: `conic-gradient(#528ac1 ${calculatePercentage(
                            starCount
                          )}%, #def 0)`,
                          display: 'inherit',
                        }}
                      >
                        <div className="inner">
                          <span>{starCount}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-block-257 skill-level">
                    {SKILL_LEVEL[starCount] || ''}
                  </div>
                </div>
              )}

              <div className="text-block-252" style={{ display: 'none' }}>
                {t('Based on')}: <span className="text-span-10"></span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};
